import { SET_APP_DATA } from '../../../../actions/app';
import { CARD_CREATE_SUCCESS } from '../../../../actions/cards/create';
import {
	FILTERED_CARD_CLEAR,
	FILTERED_CARD_FAILURE,
	FILTERED_CARD_REQUEST,
	FILTERED_CARD_SUCCESS,
	FILTERED_CARD_CLEAR_SUCCESS,
	FILTERED_CARD_CLEAR_FAILURE,
	FILTERED_CARD_CLEAR_REQUEST,
	REFILTER_SUCCESS,
} from '../../../../actions/cards/filtered-cards';
import type { Action } from '../../../../types';
import type { FilteredCardsState } from './types';

export const initialState: FilteredCardsState = {
	isLoading: false,
	filteredCardsIds: null,
};

export const filteredCardsReducer = (state: FilteredCardsState = initialState, action: Action) => {
	if (action.type === SET_APP_DATA) {
		return action.payload.ui?.cards?.filteredCards ? action.payload.ui.cards.filteredCards : state;
	}

	if (action.type === FILTERED_CARD_REQUEST || action.type === FILTERED_CARD_CLEAR_REQUEST) {
		return {
			...state,
			isLoading: true,
		};
	}

	if (action.type === FILTERED_CARD_SUCCESS) {
		return {
			isLoading: false,
			filteredCardsIds: new Set<string>(action.payload),
		};
	}

	if (action.type === FILTERED_CARD_CLEAR_FAILURE) {
		return {
			...state,
			isLoading: false,
		};
	}

	if (
		action.type === FILTERED_CARD_CLEAR ||
		action.type === FILTERED_CARD_CLEAR_SUCCESS ||
		action.type === FILTERED_CARD_FAILURE
	) {
		return initialState;
	}

	if (action.type === REFILTER_SUCCESS) {
		const { excludedCardIds, filteredCardIds } = action.payload;
		const updatedFilteredCardIds = new Set<string>([
			...(state.filteredCardsIds || []),
			...filteredCardIds,
		]);
		excludedCardIds.forEach((cardId) => updatedFilteredCardIds.delete(cardId)); // delete is faster than filtering on state
		return {
			isLoading: false,
			filteredCardsIds: updatedFilteredCardIds,
		};
	}

	if (action.type === CARD_CREATE_SUCCESS) {
		const { card } = action.payload;
		if (card?.hidden) {
			return state;
		}
		const updatedFilteredCardIds = new Set<string>([
			...(state.filteredCardsIds || []),
			String(card.id),
		]);
		return {
			isLoading: false,
			filteredCardsIds: updatedFilteredCardIds,
		};
	}

	return state;
};
